import React, { useEffect } from 'react';
import { arrayOf, bool, shape } from 'prop-types';
import AUIButton from '@ancert/aui-button';
import { AUITable } from '@ancert/aui-table';
import getColumns from './columns';
import { PAGE_SIZE } from '../../../config';
import { useFormularDenuncia } from '../../../context/formularDenuncia.context';
import { useArchivosAdjuntos } from '../../../context/archivosAdjuntos.context';

const ArchivosAdjuntos = ({ archivos, viewMode }) => {
  const { addArchivosAdjuntos, eliminarArchivoAdjunto, archivosAdjuntos } = useFormularDenuncia();
  const { archivoAdjunto, openModal, onEdit, setDownloadMode } = useArchivosAdjuntos();

  useEffect(() => {
    if (archivoAdjunto) {
      addArchivosAdjuntos(archivoAdjunto);
    }
  }, [archivoAdjunto]);

  const onRowEditar = (data) => {
    onEdit(data);
  };

  const onRowEliminar = ({ id }) => {
    eliminarArchivoAdjunto(id);
  };

  const onRowVer = (data) => {
    onEdit(data);
    setDownloadMode();
  };

  return (
    <div className="c-sii-archivos-adjuntos u-mt-24">
      <h3 className="c-sii-title-action">
        Archivos adjuntos
        {!viewMode && <AUIButton label="Adjuntar archivo" mode="secondary" onClick={openModal} />}
      </h3>
      <AUITable
        columns={getColumns({ onRowEditar, onRowEliminar, onRowVer }, viewMode)}
        data={archivos?.length === 0 ? archivosAdjuntos : archivos}
        pageSize={PAGE_SIZE.ARCHIVOS_ADJUNTOS}
        noDataText="No existen archivos adjuntos"
      />
    </div>
  );
};
ArchivosAdjuntos.propTypes = {
  archivos: arrayOf(shape({})),
  viewMode: bool,
};
ArchivosAdjuntos.defaultProps = {
  archivos: [],
  viewMode: false,
};

export default ArchivosAdjuntos;
